import React, { useContext, useEffect, useMemo, useState } from 'react';
import { App03Template, EntityValidations, IApp03Template, ISpecificEntityFormProps } from '../../types';
import styles from '../../styles/cr.module.scss';
import { CrTextField } from '../cr/CrTextField';
import { CrDropdown } from '../cr/CrDropdown';
import { EntityForm } from '../EntityForm';
import { DataContext } from '../DataContext';
import { IntegrationContext } from '../IntegrationContext';
import { App03Frameworks } from '../../types/App03Workflow';



class App03TemplateValidations extends EntityValidations {
    public Owners: string = null;
}

interface App03TemplateFormProps extends ISpecificEntityFormProps {
    frameworkID: App03Frameworks;
}

export const App03TemplateForm = (props: App03TemplateFormProps): React.ReactElement => {
    const { disableGroupManagement } = useContext(IntegrationContext);
    const { dataServices, lookupData, } = useContext(DataContext);


    const validateEntity = (template: IApp03Template): Promise<App03TemplateValidations> => {
        const errors = new App03TemplateValidations();

        if (template.Title === null || template.Title === '') {
            errors.Title = `Template name is required`;
            errors.Valid = false;
        }
        else {
            errors.Title = null;
        }

        return Promise.resolve(errors);
    };


    return (
        <EntityForm<IApp03Template, App03TemplateValidations>
            {...props}
            entityName='Template'
            renderFormFields={(changeHandlers, formState) => {
                const { FormData: template, ValidationErrors: errors } = formState;
                return (
                    <div>
                        <CrTextField
                            label="Name"
                            maxLength={100}
                            className={styles.formField}
                            required={true}
                            value={template.Title}
                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Title')}
                            errorMessage={errors.Title}
                        />

                        <CrTextField
                            label="Description"
                            multiline
                            rows={6}
                            maxLength={10000}
                            className={styles.formField}
                            value={template.Description}
                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Description')}

                        />

                    </div>
                );
            }}
            loadEntity={id => dataServices.app03TemplateService.read(id, true, true)}
            loadNewEntity={() => new App03Template(props.frameworkID)}
            loadEntityValidations={() => new App03TemplateValidations()}
            onValidateEntity={validateEntity}
            onCreate={t => dataServices.app03TemplateService.create(t)}
            onUpdate={t => dataServices.app03TemplateService.update(t.ID, t)}
            parentEntities={dataServices.app03TemplateService.parentEntities}
        // childEntities={[
        //     {
        //         ObjectParentProperty: 'App03PortfolioUsers',
        //         ParentIdProperty: 'App03PortfolioID',
        //         ChildIdProperty: 'UserID',
        //         ChildService: dataServices.app03PortfolioUserService
        //     },
        //     {
        //         ObjectParentProperty: 'CustomFields',
        //         ParentIdProperty: 'App03PortfolioID',
        //         ChildIdProperty: 'CustomFieldDefnID',
        //         ChildService: dataServices.customFieldService
        //     },
        // ]}
        />
    );
};
